import { render, staticRenderFns } from "./brands-slug-ad-list.vue?vue&type=template&id=401accb6&"
import script from "./brands-slug-ad-list.vue?vue&type=script&lang=js&"
export * from "./brands-slug-ad-list.vue?vue&type=script&lang=js&"
import style0 from "./brands-slug-ad-list.vue?vue&type=style&index=0&id=401accb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports